import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from '../../../styles/UISystem';

/**
 * IconCaretRight Component
 * 
 * A right-facing caret icon using Phosphor style
 */
const IconCaretRight = ({ 
  fill = COLORS.DARK_GRAY,
  width = 20,
  height = 20,
  style = {},
  onClick = null
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 256 256" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ 
        cursor: onClick ? 'pointer' : 'default',
        ...style
      }}
    >
      <path 
        d="M181.66 133.66l-80 80c-1.88 1.88-4.4 2.93-7.03 2.93s-5.15-1.05-7.03-2.93c-3.9-3.9-3.9-10.24 0-14.14l72.97-72.97-72.97-72.97c-3.9-3.9-3.9-10.24 0-14.14 3.9-3.9 10.24-3.9 14.14 0l80 80c3.91 3.91 3.91 10.24.07 14.15-.02 0-.05 0-.07.01-.02.01-.05.01-.07.01-.02.01-.05.01-.07.01-.02 0-.05 0-.07.01 0 .02-.01.05-.01.07-.02 0-.04.01-.06.01z"
        fill={fill}
      />
    </svg>
  );
};

IconCaretRight.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  onClick: PropTypes.func
};

export default IconCaretRight;
